const scrollToElement = ({ elem, delay = 200, isSmooth = true, topOffset = 0, }) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const top = elem === null || elem === undefined
                ? 0
                : elem.getBoundingClientRect().top + window.pageYOffset - topOffset;
            window.scrollTo({
                top,
                behavior: isSmooth ? 'smooth' : 'auto',
            });
            resolve();
        }, delay);
    });
};
export default scrollToElement;
//# sourceMappingURL=scrollToElement.js.map